import {
    GET_SELF_DATA_REQUEST,
    GET_SELF_DATA_SUCCESS,
    GET_SELF_DATA_FAIL,
    GET_REPORT_DATA_REQUEST,
    GET_REPORT_DATA_SUCCESS,
    GET_REPORT_DATA_FAIL,
    GET_USER_ATTEMPTS_REQUEST,
    GET_USER_ATTEMPTS_SUCCESS,
    GET_USER_ATTEMPTS_FAIL
} from "./constants"

export const getSelfDataRequest = (payload) => ({
    type: GET_SELF_DATA_REQUEST,
    payload,
});

export const getSelfDataSuccess = (payload) => ({
    type: GET_SELF_DATA_SUCCESS,
    payload
});

export const getSelfDataFail = (error) => ({
    type: GET_SELF_DATA_FAIL,
    error
});

export const getReportDataRequest = (payload) => ({
    type: GET_REPORT_DATA_REQUEST,
    payload,
});

export const getReportDataSuccess = (payload) => ({
    type: GET_REPORT_DATA_SUCCESS,
    payload
});

export const getReportDataFail = (error) => ({
    type: GET_REPORT_DATA_FAIL,
    error
});

export const getUserAttemptsRequest = (payload) => ({
    type: GET_USER_ATTEMPTS_REQUEST,
    payload,
});

export const getUserAttemptsSuccess = (payload) => ({
    type: GET_USER_ATTEMPTS_SUCCESS,
    payload
});

export const getUserAttemptsFail = (error) => ({
    type: GET_USER_ATTEMPTS_FAIL,
    error
});